// extracted by mini-css-extract-plugin
export default {"block":"block__LYTTLVgN","textContainer":"textContainer__ToAPcB_C"};